<template>
  <div class="c-tab-data">
    <div class="tab-data__wrapper">
      <div class="btns">
        <ElButton @click="fileDownloadClick" :loading="loading">数据导出</ElButton>
        <ElButton @click="modalColumn = true" :loading="loading">自定义列</ElButton>
      </div>
      <Viewport v-model="height">
        <el-table
          width="100%"
          ref="table"
          class="summary-el-table-styles common-el-table-styles"
          v-loading="loading"
          :data="tableData"
          :height="height - 6"
          :summary-method="summaries"
          show-summary
          border
          stripe
          @header-dragend="headerDragend"
        >
          <el-table-column
            v-for="(col, idx) in tableCol"
            :key="idx"
            :prop="col.key"
            :label="col.title"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
          >
            <template slot-scope="{ row }">
              <div class="ad-position-name" v-if="col.key === 'advPositionName'">
                <div style="margin-bottom: 10px">{{ row.advPositionName }}</div>
              </div>
              <span v-else-if="col.key.indexOf('Rate') > -1">{{ row[col.key] | toPercentFixed }}</span>
              <span v-else-if="col.key.indexOf('Retain') > -1">{{ row[col.key] | toPercentFixed }}</span>
              <span v-else-if="col.key === 'natureTimeNewRoleRoi'">{{ row[col.key] | toPercentFixed }}</span>
              <span v-else-if="toThousandsKeys.includes(col.key)">{{ row[col.key] | toThousands }}</span>
              <span v-else>{{ row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      name="detailAdPositionCustomColumn"
      v-model="modalColumn"
      :data="rawTableCols"
      :subTitle="['', '报表数据', '留存数据']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import columns from '../../../data/tab_ad_position_columns'
import { isArray, isEmpty } from '@/common/js/utils'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import { getPlanAdPositionDetail } from '@/api/ptom.data.model'
import { HOST_API } from '@/api/config'

import CustomColumn from '@/components/converter/custom-column2.vue'

const toThousandsKeys = [
  'createRoleCost',
  'payRoleCost1d',
  'realConsume',
  'payRoleEveryCost1d',
  'paperConsume',
  'pv',
  'clickNum',
  'registerNum',
  'createRoleNum',
  'payRole1d',
  'natureTimeNewRoleMoney'
]

export default {
  name: 'TabData',
  components: { CustomColumn },
  props: {
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    },
    detailTime: {
      type: Array
    }
  },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    }
  },
  methods: {
    fileDownloadClick() {
      const [begin, end] = this.detailTime || []
      const url = `${HOST_API}/api/ptom/planDataDetail/downSiteSetReport?`
      const querystring = new URLSearchParams()
      querystring.append('sessionid', this.$store.state.token)
      querystring.append('gameId', this.productId)
      querystring.append('channelId', this.chlUserId)
      querystring.append('sourceId', this.sourceId)
      querystring.append('beginDate', begin)
      querystring.append('endDate', end)
      window.open(url + querystring.toString())
    },
    getData() {
      const [beginDate, endDate] = this.detailTime || []
      const params = { gameId: this.productId, channelId: this.chlUserId, sourceId: this.sourceId, beginDate, endDate }
      this.loading = true
      getPlanAdPositionDetail(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return

            const { list, sum_data } = data
            if (isArray(list) && sum_data) {
              this.sumdata = sum_data
              this.tableData = list
              this.$nextTick(this.$refs.table.doLayout)
            } else {
              list
              this.tableData = []
            }
          }
        })
        .catch((e) => {
          this.loading = false
          this.tableData = []
          this.total = 0
        })
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      if (!data) return sums
      columns.forEach((column, index) => {
        const prop = column.property
        const val = prop && parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (isEmpty(val)) sums[index] = ''
        else if (toThousandsKeys.includes(prop)) sums[index] = toThousands(val)
        else if (prop.indexOf('Rate') > -1) sums[index] = toPercentFixed(val)
        else if (prop.indexOf('Retain') > -1) sums[index] = toPercentFixed(val)
        else if (prop === 'natureTimeNewRoleRoi') sums[index] = toPercentFixed(val)
        else sums[index] = val
      })
      return sums
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    },
    onTableColsChange(cols) {
      this.tableColumns = cols
      this.modalColumn = false
    }
  },
  watch: {
    detailTime() {
      this.pageIndex = 1
      this.getData()
    }
  },
  data() {
    return {
      toThousandsKeys,
      rawTableCols: columns,
      tableColumns: [],
      height: 330,
      loading: false,
      modalColumn: null,
      tableData: [],
      sumdata: null
    }
  },
  created() {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-tab-data {
  height: 100%;

  .material-name {
    display: flex;
    align-items: center;
    .material-item {
      height: 60px;
      display: flex;
      align-items: center;
    }

    .material-id {
      margin-left: 5px;
    }
  }

  .btns {
    text-align: right;
    padding: 5px 0;
  }
}
</style>
